import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import Camera from '../common/camera/camera';

import {
	setModoTela, initFormItem as initForm
} from './lancamentoViagemActions';
import DateFormat from '../common/dateFormat/DateFormat';

class LancamentoViagemItemForm extends Component {

	state = {

	}

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		if (this.state.eventoTirarFoto) {

			if (this.state.scrollY == -1) {
				this.setState({
					...this.state,
					scrollY: window.scrollY
				});
			}

			return <Camera eventoFoto={this.state.eventoTirarFoto} />
		}

		if (this.state.scrollY > -1) {
			const scrollY = this.state.scrollY;
			setTimeout(() => {
				window.scrollTo(0, parseInt(scrollY));
			}, 20);

			this.setState({
				...this.state,
				scrollY: -1
			});
		}

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
						
							<LabelAndInput
								maxWidth={180}
								name='datahora_lancamento'
								label='Data/Hora *' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={'readOnly'}
								value={DateFormat.formatarDataHoraSqlParaTela(this.props.formularioValues.datahora_lancamento)}
								onChange={value => {
									
								}} />

							<Field
								name='id_tipo_lancamento'
								component={Select}
								options={this.props.listaTipo}
								label='Tipo *'
								cols='12 12 12 12'
								placeholder='Selecione'
								readOnly={readOnly} />
							
							<Field
								name='valor'
								component={LabelAndInputNumber}
								label='Valor *' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								mask={2} />

							<Field
								name='descricao'
								component={LabelAndInput}
								label='Descrição' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />
						</Row>
						<Row>
							<Grid cols='12 12 12 12'>
								<Row style={{ paddingBottom: 8 }}>
									<Grid cols='12 12 12 12'>
										<label>Foto <i class={this.props.formularioValues.imagem ? `fas fa-check-double` : 'fas fa-exclamation-triangle'} style={{ color: this.props.formularioValues.imagem ? '#00a13b' : '#ff0000' }}></i></label>
									</Grid>
									{this.props.formularioValues.imagem &&
									<div style={{ marginLeft: 8, display: 'flex', flexDirection: 'row' }}>
										<span class="btn btn-outline-primary fileinput-button dz-clickable">
											<img src={this.props.formularioValues.imagem} style={{ height: 100 }} />
										</span>
										<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingRight: 2, marginTop: 4 }}>
											<button
												type='button'
												class='btn btn-flat btn-outline-danger'
												style={{ height: 38 }}
												onClick={() => {
													this.props.initForm({
														...this.props.formularioValues,
														imagem: null
													});
												}}>
												<i class='fas fa-trash-alt'></i>
											</button>
										</div>
									</div>}

									{!this.props.formularioValues.imagem &&
									<a class={`btn btn-app bg-success`}
										onClick={() => {
											this.setState({
												eventoTirarFoto: (result) => {

													this.props.initForm({
														...this.props.formularioValues,
														imagem: result
													});

													this.setState({
														eventoTirarFoto: null
													});

												}
											});
											}}>
										<i class='fas fa-camera'></i> Câmera
									</a>}
								</Row>
							</Grid>

								
						</Row>
					</ContentCardBody>
					
					<ContentCardFooter>
						<Row alignCenter>
							{!this.props.excluir &&
							<Grid cols='6 6 4 3'>
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
							</Grid>}
							{this.props.excluir &&
							<Grid cols='6 6 4 3'>
								<Button
									text='Excluir'
									submit type={'danger'}
									icon={'fa fa-trash'} />
							</Grid>}
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>

			</ContentCard>
		);
    }


}

LancamentoViagemItemForm = reduxForm({form: 'lancamentoViagemItemForm', destroyOnUnmount: false})(LancamentoViagemItemForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('lancamentoViagemItemForm')(state),
	registro: state.lancamentoViagem.registro,
	listaTipo: state.lancamentoViagem.listaTipo
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(LancamentoViagemItemForm);
